import PayingStep from "./PayingStep/PayingStep";
export const PayingStepComp = PayingStep;